import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

/**
 * Search grid column to render Date+Time values
 */
@Component({
    selector: "wbo-date-time-column",
    templateUrl: "./date-time-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => DateTimeColumnComponent), multi: true}
    ]
})
export class DateTimeColumnComponent extends AbstractColumnComponent {
    @Input() pattern: string;

    constructor(injector: Injector) {
        super(injector);
    }
}
